import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import Button from 'atoms/button';
import { DefaultAvatar } from 'atoms/default-avatar';
import Icon from 'atoms/icon';
import { InfoBlock } from 'organisms/InfoBlock';
import { openDrawer } from 'store/reducers/ui';
import { prettifyPhoneNumber } from 'util';

export function PetInformation({ pet }) {
  const dispatch = useDispatch();
  const { name, dateOfBirth, breed, sterilization, size, links, gender } =
    pet.animal;
  const { firstName, lastName, phone, email } = pet.user;

  const onEditDetails = () => {
    dispatch(
      openDrawer({
        type: 'edit-details',
        data: { animal: pet?.animal, user: pet?.user },
      })
    );
  };

  return (
    <InfoBlock>
      <div className="flex-column pet-information">
        <div className="mb-15 ml-35">
          <DefaultAvatar
            className="mb-15"
            animal={pet.animal}
            avatar={links?.image?.desktop?.small}
          />
          <h2>{name}</h2>
          {dateOfBirth && <p>{dayjs(dateOfBirth).format('MMM, DD YYYY')}</p>}
        </div>
        <div>
          {(breed?.value || size?.value) && (
            <div className="flex-row mb-30">
              <Icon className="mr-15" name="paw" />
              <p>
                {breed?.value && `${breed?.value}`}
                {breed?.value && size?.value && ', '}
                {size?.value && `${size?.value}`}
              </p>
            </div>
          )}
          {sterilization?.isSterilized && (
            <div className="flex-row mb-30">
              <Icon className="mr-15" name="neutered" />
              <p>{gender?.id === 2 ? 'Neutered' : 'Spayed'}</p>
            </div>
          )}
          <div className="flex-row mb-30">
            <Icon className="mr-15" name="user" />
            <p>{`${firstName} ${lastName}`}</p>
          </div>
          {phone && (
            <div className="flex-row mb-30">
              <Icon className="mr-15" name="phone" />
              <p>
                {prettifyPhoneNumber({
                  number: phone.number,
                  countryCode: phone.country.code.value,
                })}
              </p>
            </div>
          )}
          <div className="flex-row mb-30 email">
            <Icon className="mr-15" name="email" />
            <p className="ellipsis">{email}</p>
          </div>
        </div>
        <div className="flex-row justify-start">
          <Button
            onClick={onEditDetails}
            size="medium"
            className="ml-35 mb-100"
            variant="reverse"
            text="Edit information"
          />
        </div>
      </div>
    </InfoBlock>
  );
}
